(function ($) {

    $(document).ready(function () {
        $(".svg-wrap g.group-activated").hover(function () {
            $(this).toggleClass("hover");
        });
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/map_overview_page.es6